import {DeviceSystemData} from "../../../../app-react/services/sdk/cgp-sdk.interface";

export default class LauncherToOrbitProxyService {

    get CGP(): any {
        return (window as any).CGP;
    }

    get orbit(): any {
        return (window as any).orbit;
    }


    get allConfigs(): any {
        return (window as any).$allConfigs;
    }

    get device(): any {
        return this.CGP && this.CGP.device();
    }

    get allConfigsOrbit(): any {
        return this.allConfigs && this.allConfigs.orbit;
    }

    get allConfigsSDK(): any {
        return this.allConfigs && this.allConfigs.sdk;
    }

    get orbitConfig(): any {
        return this.allConfigsOrbit && this.allConfigsOrbit.config;
    }

    get performanceResources(): any {
        return (window as any).performance;
    }

    public isMobileNotTablet(): boolean | undefined {
        return this.device && this.device.isMobileNotTablet();
    }

    public getDeviceSystemData(): DeviceSystemData | undefined {
        return this.device && this.device.getDeviceSystemData();
    }

    public getDeviceType(): string | undefined {
        return this.getDeviceSystemData() && this.getDeviceSystemData().deviceType;
    }

    public getOperationSystem(): string | undefined {
        return this.getDeviceSystemData() && this.getDeviceSystemData().operationSystem;
    }

    public isCookieEnabled(): boolean | undefined {
        return this.device && this.device.isCookieEnable();
    }

    public getUserAgent(): string | undefined {
        return this.device && this.device.getUserAgent();
    }
    /* TO DO: ADD IS VIP */

    public getCGPVersion(): string | undefined {
        return this.CGP && this.CGP.version;
    }

    public getOrbitVersion(): string | undefined {
        return this.orbit && this.orbit.version;
    }

    public getUserData(): any | undefined {
        return this.CGP && this.CGP.getUserData();
    }

    public getUserName(): string | undefined {
        return this.getUserData() && this.getUserData().userName;
    }

    public getCID(): string | undefined {
        return this.getUserData() && this.getUserData().cid;
    }

    public isAuthorized(): boolean | undefined {
        return this.CGP && this.CGP.isAuthorized();
    }

    public getLanguage(): any {
        return this.allConfigsOrbit && this.allConfigsOrbit.lang;
    }

    public getLanguageIso3(): string | undefined {
        return this.getLanguage() && this.getLanguage().iso3;
    }

    public getCountry(): string | undefined {
        return this.allConfigs && this.allConfigs.country;
    }

    public getBrand(): number | undefined {
        return this.allConfigs && this.allConfigs.brandId;
    }

    /* Segments are no longer found where they used to be, need to find their new location */
    // public getSegments(): any {
    //     return this.app && this.app.segments;
    // }

    /* Since global object orbit was refactored, we can't take the config path from where it used to be. Need to find where it is currently exposed */
    // public getConfigurationPath(): string | undefined {
    //     return this.runTimeData && this.runTimeData.configurationPath;
    // }

    public getOrbitConfigVersion(): string | undefined {
        return this.orbitConfig && this.orbitConfig.version;
    }

    public getScreenHeight(): number | undefined {
        return this.device && this.device.getScreenHeight();
    }

    public getScreenWidth(): number | undefined {
        return this.device && this.device.getScreenWidth();
    }

    public getIOSVersion(): any {
        return this.device && this.device.getIOSVersion();
    }

    public isMobile(): boolean | undefined {
        return this.device && this.device.isMobile();
    }

    public isTablet(): boolean | undefined {
        return this.device && this.device.isTablet();
    }

    public isPC(): boolean | undefined {
        return this.device && this.device.isPC();
    }

    public isPortrait(): boolean | undefined {
        return this.device && this.device.isPortrait();
    }

    public isFirefox(): boolean | undefined {
        return this.device && this.device.isFirefox();
    }

    public isChrome(): boolean | undefined {
        return this.device && this.device.isChrome();
    }

    public isSafari(): boolean | undefined {
        return this.device && this.device.isSafari();
    }

    public isMSIE9(): boolean | undefined {
        return this.device && this.device.isMSIE9();
    }

    public isMSIE11(): boolean | undefined {
        return this.device && this.device.isMSIE11();
    }

    public isOpera(): boolean | undefined {
        return this.device && this.device.isOpera();
    }

    public isSamsungInternet(): boolean | undefined {
        return this.device && this.device.isSamsungInternet();
    }

    public isMobileByOS(): boolean | undefined {
        return this.device && this.device.isMobileByOS();
    }

    public isPokerHybrid(): boolean | undefined {
        return this.device && this.device.isPokerHybrid();
    }

    public isSportHybrid(): boolean | undefined {
        return this.device && this.device.isSportHybrid();
    }

    public getToken(): any {
        return this.CGP && this.CGP.getToken();
    }

    public getRegulationId(): string | undefined {
        return this.getToken() && this.getToken().regId;
    }

    public getCurrencyCode(): string | undefined {
        return this.getToken() && this.getToken().currencyCode;
    }

    public getProductPackage(): string | undefined {
        return this.getToken() && this.getToken().productPackage;
    }

    public getLoginType(): string | undefined {
        return this.getToken() && this.getToken().loginType;
    }

    public getErrorLogs(): any {
        return this.orbit && this.orbit.errorLogs;
    }

    public getLastOpenedGame(): any {
        return this.CGP && this.CGP.lastOpenedGame;
    }

    public getOrbitPath(): string | undefined {
        return this.allConfigsOrbit && this.allConfigsOrbit.extraProperties && this.allConfigsOrbit.extraProperties.paths && this.allConfigsOrbit.extraProperties.paths.server;
    }

    public getCGPClientPath(): string | undefined {
        return this.allConfigsSDK && this.allConfigsSDK.extraProperties && this.allConfigsSDK.extraProperties.paths && this.allConfigsSDK.extraProperties.paths.server;
    }

    public getEnviornmentOrigin(): string | undefined {
        return this.allConfigsSDK && this.allConfigsSDK.config && this.allConfigsSDK.config.Http2 && this.allConfigsSDK.config.Http2.origin;
    }
}